import {useEffect, useState} from "react";
import jwt from "jwt-decode";

export default function useUserData () {

    const [user, setUser] = useState(null);

    useEffect( () => {
        let decode = jwt(localStorage.token);
        console.log(decode);
        setUser(decode.user);
    }, []);

    return user;

}